// Shared empty state. Root CLAUDE.md: "a request with zero matched Excel
// lines is a NORMAL state, not a failure. Its empty state should invite
// manual pricing, not apologise." — every caller of this component must
// pass copy that invites the next action, never an apology.

import { useLanguage } from '../context/LanguageContext.jsx';
import styles from './EmptyState.module.css';

export default function EmptyState({ titleId, bodyId, action }) {
  const { t } = useLanguage();

  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>{t(titleId)}</p>
      <p className={styles.body}>{t(bodyId)}</p>
      {action}
    </div>
  );
}
